import {
  Popover as FluentPopover,
  PopoverProps as FluentPopoverProps,
} from '@fluentui/react-components';
import React from 'react';
import { useFluentMountNode } from '../hooks';

export type PopoverProps = FluentPopoverProps;

/**
 * Themed Popover wrapper that automatically mounts its surface into
 * `#portal-root` (inside the app FluentProvider). Consumers can still
 * override `mountNode` if they need a different target.
 *
 * All Popover sub-components (`PopoverTrigger`, `PopoverSurface`) are
 * re-exported from `@mnspro-cloud/components` for convenience.
 *
 * For a higher-level, semantic API with `trigger` / `content` props,
 * see the existing {@link Popup} component instead.
 */
export const Popover: React.FC<PopoverProps> = ({ mountNode, ...props }) => {
  const themedMountNode = useFluentMountNode();

  return <FluentPopover mountNode={mountNode ?? themedMountNode} {...props} />;
};

Popover.displayName = 'Popover';
